"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import { useEffect, useRef, useState } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { useIdentity } from "../../../hooks/useIdentity";
import { useSeizeConnectContext } from "../../auth/SeizeConnectContext";
import HeaderShare from "../../header/share/HeaderShare";
import WebSidebarHeader from "./WebSidebarHeader";
import WebSidebarNav from "./WebSidebarNav";
import WebSidebarUser from "./WebSidebarUser";
interface WebSidebarProps {
  readonly isCollapsed: boolean;
  readonly onToggle: () => void;
  readonly isMobile: boolean;
  readonly isNarrow?: boolean | undefined;
  readonly isOffcanvasOpen: boolean;
  readonly onCloseOffcanvas: () => void;
  readonly sidebarWidth: string;
}
function WebSidebar(t0) {
  const $ = _c(56);
  const {
    isCollapsed,
    onToggle,
    isMobile,
    isNarrow: t1,
    isOffcanvasOpen,
    onCloseOffcanvas,
    sidebarWidth
  } = t0;
  const isNarrow = t1 === undefined ? false : t1;
  const navRef = useRef(null);
  const pathname = usePathname();
  const {
    address
  } = useSeizeConnectContext();
  const t2 = address || "";
  let t3;
  if ($[0] !== t2) {
    t3 = {
      handleOrWallet: t2,
      initialProfile: null
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const {
    profile
  } = useIdentity(t3);
  const [isTouchScreen, setIsTouchScreen] = useState(false);
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const {
        window: browserWindow
      } = globalThis as typeof globalThis & {
        window?: Window | undefined;
      };
      if (browserWindow === undefined || typeof browserWindow.matchMedia !== "function") {
        setIsTouchScreen(false);
        return;
      }
      const coarsePointerQuery = browserWindow.matchMedia("(pointer: coarse)");
      const handlePointerChange = event => {
        setIsTouchScreen(event.matches);
      };
      setIsTouchScreen(coarsePointerQuery.matches);
      if (typeof coarsePointerQuery.addEventListener === "function") {
        coarsePointerQuery.addEventListener("change", handlePointerChange);
        return () => coarsePointerQuery.removeEventListener("change", handlePointerChange);
      }
      if ("onchange" in coarsePointerQuery) {
        const originalHandler = coarsePointerQuery.onchange;
        coarsePointerQuery.onchange = handlePointerChange;
        return () => {
          if (coarsePointerQuery.onchange === handlePointerChange) {
            coarsePointerQuery.onchange = originalHandler ?? null;
          }
        };
      }
    };
    t5 = [];
    $[2] = t4;
    $[3] = t5;
  } else {
    t4 = $[2];
    t5 = $[3];
  }
  useEffect(t4, t5);
  const prevPathnameRef = useRef(pathname);
  const isOverlayActive = isOffcanvasOpen && (isMobile || isNarrow);
  let t6;
  let t7;
  if ($[4] !== isMobile || $[5] !== isOffcanvasOpen || $[6] !== isOverlayActive || $[7] !== onCloseOffcanvas || $[8] !== pathname) {
    t6 = () => {
      if (prevPathnameRef.current !== pathname) {
        prevPathnameRef.current = pathname;
        if ((isMobile || isOverlayActive) && isOffcanvasOpen) {
          onCloseOffcanvas();
        }
      }
    };
    t7 = [pathname, isMobile, isOverlayActive, isOffcanvasOpen, onCloseOffcanvas];
    $[4] = isMobile;
    $[5] = isOffcanvasOpen;
    $[6] = isOverlayActive;
    $[7] = onCloseOffcanvas;
    $[8] = pathname;
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[11] !== isMobile || $[12] !== isOffcanvasOpen || $[13] !== isOverlayActive || $[14] !== onCloseOffcanvas) {
    t8 = () => {
      if (!isMobile && !isOverlayActive || !isOffcanvasOpen) {
        return;
      }
      const {
        window: browserWindow_0
      } = globalThis as typeof globalThis & {
        window?: Window | undefined;
      };
      if (browserWindow_0 === undefined) {
        return;
      }
      const handleEscapeKey = e => {
        if (e.key === "Escape") {
          onCloseOffcanvas();
        }
      };
      browserWindow_0.addEventListener("keydown", handleEscapeKey);
      return () => browserWindow_0.removeEventListener("keydown", handleEscapeKey);
    };
    t9 = [isMobile, isOffcanvasOpen, isOverlayActive, onCloseOffcanvas];
    $[11] = isMobile;
    $[12] = isOffcanvasOpen;
    $[13] = isOverlayActive;
    $[14] = onCloseOffcanvas;
    $[15] = t8;
    $[16] = t9;
  } else {
    t8 = $[15];
    t9 = $[16];
  }
  useEffect(t8, t9);
  const shouldShowCollapsed = isMobile && isOffcanvasOpen ? false : isCollapsed;
  const scrollContainerRef = useRef(null);
  let t10;
  if ($[17] !== onToggle) {
    t10 = () => {
      navRef.current?.closeSubmenu();
      onToggle();
    };
    $[17] = onToggle;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const handleToggle = t10;
  const shouldRenderSidebar = !isMobile || isOffcanvasOpen;
  if (!shouldRenderSidebar) {
    return null;
  }
  let t11;
  if ($[19] !== isMobile || $[20] !== isOverlayActive || $[21] !== onCloseOffcanvas) {
    t11 = isOverlayActive && <button type="button" className={isMobile ? "tw-fixed tw-inset-0 tw-bg-gray-600 tw-bg-opacity-50 tw-z-[70] tw-border-0 focus:tw-outline-none" : "tw-fixed tw-inset-0 tw-bg-gray-600 tw-bg-opacity-50 tw-z-30 tw-border-0 focus:tw-outline-none"} onClick={onCloseOffcanvas} aria-label="Close menu overlay" />;
    $[19] = isMobile;
    $[20] = isOverlayActive;
    $[21] = onCloseOffcanvas;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const t12 = isMobile ? "tw-fixed tw-inset-y-0 tw-left-0 tw-z-[80] focus:tw-outline-none" : "tw-fixed tw-inset-y-0 tw-left-0 focus:tw-outline-none tw-z-40";
  let t13;
  if ($[23] !== isMobile) {
    t13 = isMobile ? undefined : {
      left: "var(--layout-margin, 0px)"
    };
    $[23] = isMobile;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== sidebarWidth) {
    t14 = {
      width: sidebarWidth
    };
    $[25] = sidebarWidth;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== handleToggle || $[28] !== shouldShowCollapsed) {
    t15 = <WebSidebarHeader collapsed={shouldShowCollapsed} onToggle={handleToggle} />;
    $[27] = handleToggle;
    $[28] = shouldShowCollapsed;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  let t17;
  if ($[30] !== shouldShowCollapsed) {
    t16 = <div className="tw-flex-1"><WebSidebarNav ref={navRef} isCollapsed={shouldShowCollapsed} /></div>;
    t17 = <HeaderShare isCollapsed={shouldShowCollapsed} />;
    $[30] = shouldShowCollapsed;
    $[31] = t16;
    $[32] = t17;
  } else {
    t16 = $[31];
    t17 = $[32];
  }
  let t18;
  if ($[33] !== profile || $[34] !== shouldShowCollapsed) {
    t18 = <WebSidebarUser isCollapsed={shouldShowCollapsed} profile={profile} />;
    $[33] = profile;
    $[34] = shouldShowCollapsed;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t16 || $[37] !== t17 || $[38] !== t18) {
    t19 = <div className="tw-flex tw-flex-col tw-h-full tw-overflow-y-auto tw-overflow-x-hidden tw-scrollbar-thin no-scrollbar tw-scrollbar-thumb-iron-500 tw-scrollbar-track-iron-800 desktop-hover:hover:tw-scrollbar-thumb-iron-300" data-sidebar-scroll="true">{t16}{t17}{t18}</div>;
    $[36] = t16;
    $[37] = t17;
    $[38] = t18;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t15 || $[41] !== t19) {
    t20 = <div className="tw-flex tw-flex-col tw-h-full tw-pt-2">{t15}{t19}</div>;
    $[40] = t15;
    $[41] = t19;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t14 || $[44] !== t20) {
    t21 = <div className="tw-group tw-relative tw-z-50 tw-h-full tw-bg-black tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-iron-800 tw-border-0 tw-transition-[width] tw-duration-300 tw-ease-in-out focus:tw-outline-none" style={t14} aria-label="Primary sidebar" ref={scrollContainerRef}>{t20}</div>;
    $[43] = t14;
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== t12 || $[47] !== t13 || $[48] !== t21) {
    t22 = <div className={t12} style={t13}>{t21}</div>;
    $[46] = t12;
    $[47] = t13;
    $[48] = t21;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== isTouchScreen) {
    t23 = !isTouchScreen && <ReactTooltip id="sidebar-tooltip" place="right" offset={16} opacity={1} style={{
      padding: "4px 8px",
      background: "#37373E",
      color: "white",
      fontSize: "13px",
      fontWeight: 500,
      borderRadius: "6px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      zIndex: 9999,
      pointerEvents: "none"
    }} border="1px solid #4C4C55" />;
    $[50] = isTouchScreen;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  let t24;
  if ($[52] !== t11 || $[53] !== t22 || $[54] !== t23) {
    t24 = <>{t11}{t22}{t23}</>;
    $[52] = t11;
    $[53] = t22;
    $[54] = t23;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  return t24;
}
export default WebSidebar;